
import axios from 'axios'
// import env from '../lib/env'
export const config = { baseURL: process.env.REACT_APP_AUTH_URL }

const api = axios.create(config)
export default api
